export default __webpack_public_path__ + "static/media/Illustracion_media_superior.136fd323.png";